/*
 * Collection color swatches only see products on the current page (26).
 * Colorways of the same style often sit further down the collection, so the
 * product page shows them and the grid does not.
 *
 * For cards that fell back to the on-page list, look up the style by handle
 * prefix (text before the first "_", same rule as the PDP) and append any
 * available color that is not already drawn. Title is not compared.
 */
(function () {
  if (window.__fmPlpSwatches) return;
  window.__fmPlpSwatches = true;

  var cache = {};
  var scanTimer = null;

  function prefixOf(handle) {
    return (handle || '').split('_')[0];
  }

  function handleFromUrl(url) {
    var path = (url || '').split('?')[0];
    var marker = '/products/';
    var idx = path.indexOf(marker);
    if (idx === -1) return '';
    try {
      return decodeURIComponent(path.slice(idx + marker.length));
    } catch (e) {
      return path.slice(idx + marker.length);
    }
  }

  function swatchFiles(handle) {
    var last = (handle || '').split('_').pop() || '';
    var underscored = last.replace(/-/g, '_').toLowerCase();
    var cap = underscored.charAt(0).toUpperCase() + underscored.slice(1);
    var words = last.replace(/-/g, ' ').toLowerCase().split(/\s+/).filter(Boolean).map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('_');
    var files = [];
    function add(name) {
      if (name && files.indexOf(name) === -1) files.push(name);
    }
    add(underscored + '.png');
    add(cap + '.png');
    add(words + '.png');
    add(underscored + '.jpg');
    add(words + '.jpg');
    add(underscored + '.JPG');
    var label = last.replace(/-/g, ' ').replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
    return { label: label || last, files: files };
  }

  function paintSwatch(link, files, index) {
    if (!files || index >= files.length) {
      var letter = document.createElement('span');
      letter.textContent = (link.getAttribute('title') || '?').charAt(0).toUpperCase();
      letter.style.cssText = 'font-size:9px;font-weight:700;color:#888;';
      link.style.backgroundColor = '#f4f4f4';
      link.appendChild(letter);
      return;
    }
    var img = new Image();
    img.onload = function () {
      link.style.background = 'url(' + img.src + ') center/cover no-repeat';
    };
    img.onerror = function () { paintSwatch(link, files, index + 1); };
    img.src = '/cdn/shop/files/' + files[index];
  }

  function fetchSiblings(prefix) {
    if (!prefix) return Promise.resolve([]);
    if (cache[prefix]) return cache[prefix];
    var url = '/search/suggest.json?q=' + encodeURIComponent(prefix) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
    cache[prefix] = fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        return products.filter(function (product) {
          var handle = handleFromUrl(product.url);
          product._handle = handle;
          return product.available !== false && prefixOf(handle) === prefix && handle;
        });
      })
      .catch(function () { return []; });
    return cache[prefix];
  }

  function syncMore(container) {
    var items = container.querySelectorAll('.swatch-item-container');
    var extra = items.length - 5;
    for (var i = 0; i < items.length; i++) {
      items[i].style.display = i < 5 ? '' : 'none';
    }
    var more = container.querySelector('[data-fm-swatch-more]');
    if (extra > 0) {
      if (!more) {
        more = document.createElement('span');
        more.setAttribute('data-fm-swatch-more', '');
        more.style.cssText = 'font-size:11px;color:#777;font-weight:600;';
        container.appendChild(more);
      }
      more.textContent = '+' + extra;
    } else if (more) {
      more.remove();
    }
  }

  function addSwatch(container, handle, currentHandle) {
    var info = swatchFiles(handle);
    var isCurrent = handle === currentHandle;
    var wrap = document.createElement('div');
    wrap.className = 'swatch-item-container';
    wrap.style.position = 'relative';
    var link = document.createElement('a');
    link.href = '/products/' + handle;
    link.className = 'collection-swatch-link' + (isCurrent ? ' active' : '');
    link.setAttribute('data-fm-swatch-handle', handle);
    link.title = info.label;
    link.style.cssText = 'width:18px;height:18px;border-radius:50%;border:1px solid #dcdcdc;display:flex;align-items:center;justify-content:center;overflow:hidden;' +
      (isCurrent ? 'box-shadow:0 0 0 1px #fff, 0 0 0 2px #000;z-index:2;' : '');
    wrap.appendChild(link);
    var more = container.querySelector('[data-fm-swatch-more]');
    if (more) container.insertBefore(wrap, more);
    else container.appendChild(wrap);
    paintSwatch(link, info.files, 0);
  }

  function fill(container, siblings) {
    var current = container.getAttribute('data-fm-handle') || '';
    var existing = {};
    container.querySelectorAll('[data-fm-swatch-handle]').forEach(function (link) {
      existing[link.getAttribute('data-fm-swatch-handle')] = true;
    });
    siblings.forEach(function (product) {
      if (!existing[product._handle]) {
        existing[product._handle] = true;
        addSwatch(container, product._handle, current);
      }
    });
    var count = container.querySelectorAll('.swatch-item-container').length;
    if (count > 1) {
      container.classList.remove('fm-swatches-pending');
      syncMore(container);
    }
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-fm-swatch-source="page"]');
    nodes.forEach(function (container) {
      if (container.getAttribute('data-fm-swatch-pending') === '1') return;
      if (container.getAttribute('data-fm-swatch-done') === '1') return;
      container.setAttribute('data-fm-swatch-pending', '1');
      fetchSiblings(container.getAttribute('data-fm-prefix') || '')
        .then(function (siblings) {
          if (!container.isConnected) return;
          if (siblings.length > 1) fill(container, siblings);
          container.setAttribute('data-fm-swatch-done', '1');
        })
        .finally(function () {
          container.removeAttribute('data-fm-swatch-pending');
        });
    });
  }

  function schedule(root) {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () { scan(root || document); }, 60);
  }

  function boot() {
    scan(document);
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid || grid.__fmSwatchObs) return;
    grid.__fmSwatchObs = new MutationObserver(function () { schedule(grid); });
    grid.__fmSwatchObs.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
